<form class="advanced-search-form" [formGroup]="form" (submit)="searchData()">
  <div class="advanced-search-controls-line">
    <iv-live-dropdown-new
      class="advanced-search-control"
      formControlName="market"
      label="Market"
      withoutHover
      contentWidth
      [templateField]="{list: 'name', input: 'name'}"
      [listValues]="markets"
      [placeholder]="locale.selectMarket"
    ></iv-live-dropdown-new>

    <iv-live-text-input
      class="advanced-search-control"
      formControlName="company"
      label="Company"
    ></iv-live-text-input>
  </div>

  <div class="advanced-search-controls-line">
    <iv-live-text-input
      class="advanced-search-control"
      formControlName="instrument"
      label="Instrument"
    ></iv-live-text-input>

    <iv-live-text-input
      class="advanced-search-control"
      formControlName="exchange"
      label="Exchange"
    ></iv-live-text-input>
  </div>

  <div class="search-section">
    <div class="matching-type">
      <div class="matching-type__radio" *ngFor="let type of matchingTypes">
        <input
          formControlName="matchingTypeControl"
          [id]="type"
          name="matchingTypeControl"
          type="radio"
          [value]="type"
        />

        <label for="{{type}}">{{type | lowercase}}</label>
      </div>
    </div>

    <button
      class="iv-flat-button"
      type="submit"
      [disabled]="form.disabled"
    >
      Search
    </button>
  </div>

  <div class="grid-section">
    <iv-live-grid
      class="grid-off-scroll"
      (checkboxClick)="onCheckboxClick($event)"
      (allRowsSelection)="toggleAllRowsSelection($event)"
      (symbolClicked)="onSymbolClick($event)"
      [columns]="gridColumns"
      [data]="result"
      [emptyMessage]="($isLoading | async) ? 'Loading...' : 'No tools were found matching your request.'"
      [visibleColumns]="visibleColumns"
      [offScroll]="true"
      [isNeedCalculators]="false"
    >
    </iv-live-grid>
  </div>

  <div class="actions-section">
    <div class="pagination">
      <ng-container
        *ngTemplateOutlet="navButton; context:{page: 1, currentPage: form.controls.currentPage.value, disablePage: 1, content: '&#xE5DC;'}"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="navButton; context:{page: +form.controls.currentPage.value - 1, currentPage: form.controls.currentPage.value, disablePage: 1, content: '&#xE5CB;'}"
      ></ng-container>
        Page
      <input formControlName="currentPage" name="page">
        of {{pagesCount}}
      <ng-container
        *ngTemplateOutlet="navButton; context:{page: +form.controls.currentPage.value + 1, currentPage: form.controls.currentPage.value, disablePage: pagesCount, content: '&#xE5CC;'}"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="navButton; context:{page: pagesCount, currentPage: form.controls.currentPage.value, disablePage: pagesCount, content: '&#xE5DD;'}"
      ></ng-container>
    </div>

    <div class="advanced-search-buttons-container">
      <button
        *ngIf="hasMultipleChoice"
        class="iv-flat-button iv-flat-button-alert button cancel"
        type="button"
        (click)="closeDialog.emit()"
        [disabled]="form.disabled"
      >
        Cancel
      </button>

      <button
        *ngIf="hasMultipleChoice"
        class="iv-flat-button"
        type="button"
        (click)="onAddSymbolsClick()"
        [disabled]="form.disabled"
      >
        Add
      </button>
    </div>
  </div>
</form>

<ng-template
  #navButton
  let-content="content"
  let-currentPage="currentPage"
  let-disablePage="disablePage"
  let-page="page"
>
  <button
    (click)="onPageButtonClick(page)"
    [disabled]="currentPage === disablePage || form.disabled || pagesCount === 0"
    class="iv-img-button"
    type="button"
  >
    <div class='square-content'>
      <div>
        <span class="material-icons">{{content}}</span>
      </div>
    </div>
  </button>
</ng-template>
